import { useState, useEffect, useMemo } from 'react'
import * as API from '../lib/JerseyDirectoryAPI'
import * as FilterLogic from '../lib/ListingFilterLogic'

function UseList(startCategory, startSubCategory, startSearchText, startLocation) {
    // Initial states
    const [category, setCategory] = useState(startCategory);
    const [subCategory, setSubCategory] = useState(startSubCategory);
    const [searchText, setSearchText] = useState(startSearchText);
    const [location, setLocation] = useState(startLocation);
    const [isQueenOfQuality, setIsQueenOfQuality] = useState(false);
    const [displayOption, setDisplayOption] = useState(null);
    const [isPerformanceProgram, setIsPerformanceProgram] = useState('');
    const [sortDirection, setSortDirection] = useState('nameAZ');

    // Data states
    const [activeEntries, setActiveEntries] = useState([]);
    const [isActiveEntriesLoaded, setIsActiveEntriesLoaded] = useState(false);
    const [filteredEntries, setFilteredEntries] = useState([]);
    const [isEntriesFiltered, setIsEntriesFiltered] = useState(false);
    const [resultsCount, setResultsCount] = useState(0);

    // Load initial active entries
    useEffect(() => {
        API.getActiveDirectoryEntries().then((res) => {
            const deserializedEntries = res.data;
            setActiveEntries(deserializedEntries);
            setIsActiveEntriesLoaded(true);
        });
    }, []);

    // Filter effect (runs only when filter criteria change)
    const baseFilteredEntries = useMemo(() => {
        if (!isActiveEntriesLoaded) return [];

        const filterData = async () => {
            setIsEntriesFiltered(false);
            const filtered = await FilterLogic.filterListings(
                activeEntries,
                category,
                subCategory,
                location,
                searchText,
                isQueenOfQuality,
                isPerformanceProgram
            );
            setIsEntriesFiltered(true);
            return filtered;
        };

        const result = filterData();
        return result;
    }, [
        activeEntries,
        category,
        subCategory,
        location,
        searchText,
        isQueenOfQuality,
        isPerformanceProgram,
        isActiveEntriesLoaded
    ]);

    // Sort effect (runs when base filtered entries or sort direction change)
    useEffect(() => {
        async function applySorting() {
            if (!isActiveEntriesLoaded) return;

            const filteredData = await baseFilteredEntries;
            const sortedData = await FilterLogic.sortDataBy([...filteredData], sortDirection);
            setFilteredEntries(sortedData);
            setResultsCount(sortedData.length);
        }

        applySorting();
    }, [baseFilteredEntries, sortDirection, isActiveEntriesLoaded]);

    return {
        category,
        setCategory,
        subCategory,
        setSubCategory,
        searchText,
        setSearchText,
        location,
        setLocation,
        isQueenOfQuality,
        setIsQueenOfQuality,
        resultsCount,
        isActiveEntriesLoaded,
        filteredEntries,
        isEntriesFiltered,
        sortDirection,
        setSortDirection,
        displayOption,
        setDisplayOption,
        isPerformanceProgram,
        setIsPerformanceProgram
    };
}

export default UseList;